<template>
	<section id="home">
		<div class="home-page">
			<header class="container">
				<nav-bar />
			</header>

			<main class="container">
				<CadastrarColecao @boxCreate="createCollection" :boxCadastro="boxCadastro" v-if="boxCadastro"/>

				<img src="@/assets/images/ensineme.png" alt="Logo do Joana">
				<div class="control-check">
					<span>Pesquise Por: &nbsp;</span>
					<div :class="[typeOption === false ? 'ativo' : 'inativo']">Coleções</div>
					<div class="">
						<toggle-button :value="true" @change="onChangeEventHandler" />
					</div>
					<div :class="[typeOption === true ? 'ativo' : 'inativo']">Objetos</div>
				</div>

				<!-- <search-area /> -->
				<section class="search-by-type" v-if="typeOption === true">
					<!--<type-button @boxCreate="createCollection" :boxCadastro="boxCadastro"
					iconCollection="fas" iconName="folder-plus" title="Criar coleção" :wideIcon="true"
					:createCollection="createCollection" />-->
					<span class="desc">Filtre por tipo de objetos:</span>
					<type-button v-for="tipo in tipos" :key="tipo.id" @changeTipo="setTipo" :id="tipo.id" :iconName="tipo.icone"
					:title="tipo.title || tipo.nome" :url="`/resultado/objeto?tipos=${tipo.id}&buscarPor=objeto`" />
				</section>
			</main>

			<div class="container" v-if="typeOption === true">
				<div class="entry">
					<div class="curation">
						<multiselect v-model="form.curadoria" :options="curadorias" :close-on-select="true"
							:clear-on-select="true"
							:show-labels="false"
							:searchable="true" placeholder="Selecione a curadoria" :showNoResults="true"
							selectedLabel="Selecionado"
							label="nome" track-by="nome"
							@select="selectCuradoria">
								<template slot="noResult">
									Nenhuma curadoria encontrada
								</template>

								<template slot="noOptions">
									Nenhuma curadoria encontrada
								</template>
							</multiselect>
					</div>
					<div class="subCuration">
						<multiselect v-model="form.subCuradoria" :options="subCuradorias" :close-on-select="true"
							:clear-on-select="true"
							:show-labels="false"
							:searchable="true" placeholder="Selecione a sub-curadoria" :showNoResults="true"
							selectedLabel="Selecionado"
							label="nome" track-by="nome"
							@select="selectSubCuradoria">
								<template slot="noResult">
									Nenhuma sub-curadoria encontrada
								</template>

								<template slot="noOptions">
									Nenhuma sub-curadoria encontrada
								</template>
							</multiselect>
					</div>
					<div class="eixo">
						<multiselect v-model="form.eixo" :options="eixo" :close-on-select="true"
							:clear-on-select="true"
							:show-labels="false"
							:searchable="true" placeholder="Selecione o eixo" :showNoResults="true"
							selectedLabel="Selecionado"
							label="nome" track-by="nome">
								<template slot="noResult">
									Nenhuma eixo encontrado
								</template>

								<template slot="noOptions">
									Nenhuma eixo encontrado
								</template>
							</multiselect>
					</div>
				</div>
				<div class="entry">
					<div class="right">
						<div class="search">
							<input class="input-titulo" type="text" placeholder="Pesquise por título, descrição, autor, fonte, e propriedades do tipo do objeto"
							v-model.lazy="form.texto" maxlength="200" />

							<i class="fas fa-search"></i>
						</div>
					</div>

					<div class="date-search">
						<datepicker v-model="form.data" placeholder="Selecione a data"
						:clear-button="true" format="dd/MM/yyyy" :language="lang"
						input-class="input-class teste"></datepicker>
						<i class="material-icons">today</i>
					</div>
				</div>
				<div class="entry">
					<div class="right">
					<!-- 3 - Cursos Recorrentes, 2 - Disciplinas Recorrentes -->
						<div class="search">
							<input class="input-curros-recorrentes" type="text" v-model="cursoNome"
							placeholder="Pesquisar por cursos recorrentes" maxlength="200"
							@keyup="(e) => changeCursosRecorrente(e)" />
							<i class="fas fa-search"></i>
						</div>
						<div class="list">
							<ul>
								<li v-for="curso in cursosRecorrentes" :key="curso.id"
									@click="() => selectDisciplina(curso, 3)">{{curso.nome}}</li>
							</ul>
						</div>
					</div>
					<div class="right">
						<div class="search">
							<input class="input-displinas-recorrentes" type="text" v-model="disciplinaNome"
								placeholder="Pesquisar por disciplinas recorrentes" maxlength="200"
								@keyup="(e) => changeDisciplinasRecorrente(e)"  />
							<i class="fas fa-search"></i>
						</div>
						<div class="list">
							<ul>
								<li v-for="disciplina in disciplinasRecorrentes" :key="disciplina.id"
									@click="() => selectDisciplina(disciplina, 2)">{{disciplina.nome}}</li>
							</ul>
						</div>
					</div>
					<div class="left">
						<i class="fas fa-search"></i>
						<input class="botao" value="Pesquisar" @click="search" type="submit" />
					</div>
				</div>
			</div>
			<div class="container" v-if="typeOption === false">
				<div class="entry-colecttion">
					<div class="right">
						<input class="input-titulo" type="text" placeholder="Pesquise por título" v-model.lazy="form.texto"
						maxlength="200" />
						<i class="fas fa-search"></i>
					</div>
					<div class="left">
						<i class="fas fa-search"></i>
						<input class="botao" value="Pesquisar" @click="search" type="submit" />
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</section>
</template>

<script>
import CadastrarColecao from '@/components/views/colecoes/inc/CadastrarColecao'
import momentTimezone from 'moment-timezone'
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import NavBar from '@/components/shared/NavBar'
// import SearchArea from '@/components/shared/SearchArea'
import Footer from '@/components/shared/Footer'
import TypeButton from '@/components/shared/TypeButton'
import { tipos } from '@/services/tipos'
import { tags } from '@/services/tags'
import { curadorias } from '@/services/curadorias'

export default {
	name: 'homePage',
	components: { NavBar, TypeButton, CadastrarColecao, Footer, Datepicker },
	data () {
		return {
			form: {
				texto: '',
				tipos: [],
				type: 'objeto',
				data: '',
				curadoria: '',
				subCuradoria: '',
				eixo: '',
				cursoId: '',
				disciplinaId: ''
			},
			cursoNome: '',
			disciplinaNome: '',
			tipos: [],
			cursosRecorrentes: [],
			disciplinasRecorrentes: [],
			curadorias: [],
			subCuradorias: [],
			eixo: [],
			titulo: '',
			data: '',
			lang: ptBR,
			boxCadastro: false,
			typeOption: true
		}
	},
	created () {
		this.buscarTipos()
		this.buscarCuradorias()
	},
	methods: {
		Cadastro () {
			this.boxCadastro = !this.boxCadastro
		},
		createCollection (boxCreate) {
			this.boxCadastro = typeof boxCreate !== 'undefined'
		},
		async buscarTipos () {
			await tipos.find({ status: true })
				.then(res => {
					this.tipos = res.data
					// 	this.tipos = res.data.sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase()).map(tipo => {
					// 		tipo.collection = 'fas'
					// 		switch (tipo.nome.toLowerCase()) {
					// 		case 'games': case 'game':
					// 			tipo.icon = 'gamepad'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'livros': case 'livro':
					// 			tipo.icon = 'book'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'livro externo':
					// 			tipo.icon = 'book'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'temas': case 'tema':
					// 			tipo.icon = 'graduation-cap'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'videos': case 'video': case 'vídeos': case 'vídeo':
					// 			tipo.collection = 'fab'
					// 			tipo.icon = 'youtube'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'imagens': case 'imagem':
					// 			tipo.icon = 'image'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'documentos': case 'documento':
					// 			tipo.icon = 'file-alt'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'links': case 'link':
					// 			tipo.icon = 'link'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		case 'podcasts': case 'podcast':
					// 			tipo.icon = 'microphone-alt'
					// 			tipo.title = tipo.nome
					// 			tipo.key = tipo.id
					// 			break
					// 		default:
					// 			tipo.collection = null
					// 		}

					// 		return tipo
					// 	}).filter(tipo => tipo.flagAtivo && tipo.title)
				})
		},
		async buscarCuradorias () {
			const retornoCuradorias = await curadorias.findByTree()
			this.curadorias = retornoCuradorias.data
		},
		selectCuradoria (option) {
			console.log('fdsfds', option)
			this.subCuradorias = []
			this.form.subCuradoria = ''
			this.form.eixo = ''
			this.eixo = []
			this.subCuradorias = option.subCuradorias
		},
		selectDisciplina (item, identificador) {
			if (identificador === 2) {
				this.form.disciplinaId = item.id
				this.disciplinaNome = item.nome
				this.disciplinasRecorrentes = []
			}
			if (identificador === 3) {
				this.form.cursoId = item.id
				this.cursoNome = item.nome
				this.cursosRecorrentes = []
			}
		},
		async changeCursosRecorrente (e) {
			if (e.target.value.length > 2) {
				const retorno = await tags.findByNome(e.target.value, 3)
				this.cursosRecorrentes = retorno.data
			} else {
				this.cursosRecorrentes = []
			}
		},
		async changeDisciplinasRecorrente (e) {
			if (e.target.value.length > 2) {
				const retornoCuradorias = await tags.findByNome(e.target.value, 2)
				this.disciplinasRecorrentes = retornoCuradorias.data
			} else {
				this.disciplinasRecorrentes = []
			}
		},
		selectSubCuradoria (option) {
			this.form.eixo = ''
			this.eixo = []
			this.eixo = option.subCuradorias
		},
		setTipo (id) {
			const index = this.form.tipos.findIndex(t => t.toString() === id.toString())
			if (index !== -1) {
				this.form.tipos.splice(index, 1)
			} else {
				this.form.tipos.push(id)
			}
		},
		search () {
			if (this.form.type === 'collection') {
				this.$router.push({ name: 'resultadoColecao', query: { texto: this.form.texto, buscarPor: 'colecao' } })
			} else {
				const filters = {
					texto: this.form.texto,
					tipos: this.form.tipos.toString(),
					curadorias: this.form.curadoria.id ? this.form.curadoria.id : '',
					subcuradorias: this.form.subCuradoria.id ? this.form.subCuradoria.id : '',
					eixos: this.form.eixo.id ? this.form.eixo.id : '',
					cursoId: this.form.cursoId,
					disciplinaId: this.form.disciplinaId,
					data: this.form.data ? momentTimezone(this.form.data).format('DD/MM/YYYY') : '',
					buscarPor: this.form.type
				}
				this.$router.push({ name: 'resultadoObjeto', query: filters })
			}
		},
		customFormatter (date) {
			const data = momentTimezone(date).format('DD/MM/YYYY')
			this.form.data = data
			return data
		},
		onChangeEventHandler () {
			this.typeOption = !this.typeOption
			if (!this.typeOption) {
				this.form.type = 'collection'
			} else {
				this.form.type = 'object'
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.home-page {
	background: url(../../../assets/images/bgblue.png) no-repeat;
	background-size: cover;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: stretch;

	header {
		width: 100%;
	}

	main {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
		padding-top: 50px;

		img {
			width: 260px;
		}

		.search-area {
			display: flex;
			min-width: 700px;
			height: 42px;
			margin-top: 90px;

			@media (max-width: 760px) {
				min-width: 100%;
				width: 100%;
			}

			input {
				height: 100%;
				width: 100%;
				outline: none;
				border: none;
				padding-left: 16px;
				font-size: 1em;
				color: $main-color;
				border-top-left-radius: 5px;
				border-bottom-left-radius: 5px;
			}

			.vertical-separator {
				height: 100%;
				width: 120px;
				background: #fff;
				display: flex;
				align-items: center;
				justify-content: center;

				.line {
					height: 60%;
					width: 1px;
					background: #ccc;
					margin-right: 10px;
				}

				span {
					font-size: .8em;
				}
			}

			select {
				border: none;
				outline: none;
				font-size: .9em;
			}

			button {
				background-color: $main-color;
				color: #fff;
				border: none;
				height: 100%;
				outline: none;
				cursor: pointer;
				font-size: .9em;
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
				padding: 0 10px;
			}
		}

		h2 {
			margin: 42px 0 18px;
			color: #fff;
			font-size: 1em;
		}

		.search-by-type {
			padding-top: 60px;
			display: flex;
			flex-wrap: wrap;
			.desc {
				color: #fff;
				font: Condensed 12px/26px Roboto;
				font-size: 12px;
			}
		}
	}

	.custom-icon {
		width: 18px;
		height: 32px;
		padding: 4px;
		margin-bottom: 20px;
		border: 2px solid #FFF;
		border-radius: 100px;

		&::before {
			content: '';
			display: block;
			width: 6px;
			height: 12px;
			border-radius: 100px;
			background-color: #FFF;
		}
	}
	.container {
		.entry {
			display: flex;
			flex-wrap: wrap;
			.curation {
				width: 265px;
				margin-bottom: 15px;
				margin-right: 10px;
			}
			.date-search {
				position: relative;
				margin-bottom: 15px;
				cursor: pointer;
				.material-icons {
					position: absolute;
					top: 8px;
				}
			}
			.subCuration {
				width: 336px;
				margin-right: 10px;
				margin-bottom: 15px;
			}
			.eixo {
				width: 351px;
				margin-bottom: 15px;
			}
			.right {
				.search {
					display: flex;
					position: relative;
					.fa-search {
						position: absolute;
						right: 15px;
						top: 10px;
						cursor: pointer;
					}
				}
				.list {
					position: relative;
					top: -15px;
					ul {
						background: #e8e8e8;
						border-radius: 4px;
						max-height: 200px;
						overflow-y: scroll;
						margin-right: 10px;
						li {
							color: #35495e;
							height: 45px;
							background: #fff;
							padding: 12px;
							&:hover {
								background: #41b883;
								color: #fff;
							}
						}
					}
				}
			}
			.left {
				display: flex;
				position: relative;
				.fa-search {
					position: absolute;
					left: 52px;
					top: 12px;
					color: #fff;
				}
			}
			.input-titulo {
				margin-bottom: 15px;
				margin-right: 10px;
				width: 753px;
				height: 40px;
				border: 0;
				border-radius: 4px;
			}
			.input-data {
				margin-bottom: 15px;
				width: 209px;
				height: 40px;
			}
			.input-curros-recorrentes {
				margin-bottom: 15px;
				margin-right: 10px;
				width: 330px;
				height: 40px;
				border: 0;
				border-radius: 4px;
			}
			.input-displinas-recorrentes {
				margin-bottom: 15px;
				margin-right: 10px;
				width: 380px;
				height: 40px;
				border: 0;
				border-radius: 4px;
			}
			.botao {
				margin-bottom: 15px;
				border: 0;
				border-radius: 4px;
				width: 244px;
				height: 40px;
				border: 0;
				color: #fff;
				font: Condensed Bold 16px/19px Roboto;
				background: transparent linear-gradient(0deg, #224894 0%, #00F3F3 100%) 0% 0% no-repeat padding-box;
				cursor: pointer;
			}
		}
		.entry-colecttion {
			display: flex;
			flex-wrap: wrap;
			padding-top: 40px;
			.right {
				display: flex;
				position: relative;
				.fa-search {
					position: absolute;
					right: 15px;
					top: 10px;
				}
			}
			.input-titulo {
				margin-bottom: 15px;
				margin-right: 10px;
				width: 716px;
				height: 40px;
				border: 0;
				border-radius: 4px;
			}
			.left {
				display: flex;
				position: relative;
				.fa-search {
					position: absolute;
					left: 52px;
					top: 12px;
					color: #fff;
				}
			}
			.botao {
				margin-bottom: 15px;
				border: 0;
				border-radius: 4px;
				width: 244px;
				height: 40px;
				border: 0;
				color: #fff;
				font: Condensed Bold 16px/19px Roboto;
				background: transparent linear-gradient(0deg, #224894 0%, #00F3F3 100%) 0% 0% no-repeat padding-box;
			}
		}
	}
	.control-check {
		display: flex;
		font: Condensed Bold 20px/26px Roboto;
		span {
			color: #fff;
		}
		div {
			margin-right: 6px;
			color: #000;
		}
		.inativo {
			color: #59708F;
		}
		.ativo {
			color: #FFFFFF;
		}
	}
}

footer {
	margin-top: -120px;
}
input {
	padding-left: 10px;
}
//@media (max-width: 760px) {
@media screen and (max-width: 700px) {
	.home-page {
		.container  {
			.entry {
				display: flex;
				flex-wrap: wrap;
				flex-direction: column;
				.curation {
					width: 320px;
				}
				.subCuration {
					width: 320px;
				}
				.eixo {
					width: 320px;
				}
				.right {
					input {
						width: 320px;
					}
				}
				.botao {
					width: 320px;
				}
			}
			.entry-colecttion {
				display: flex;
				flex-direction: column;
				.right {
					input {
						width: 320px;
					}
				}
				.botao {
					width: 320px;
				}
			}
		}
	}
	.input-class {
		width: 320px !important;
	}
	footer {
		margin-top: 306px;
	}
}

</style>

<style>
	.v-switch-core {
		background-color: #0083CB !important;
	}
	.multiselect__option {
		display: block;
		padding: 12px;
		min-height: 40px;
		line-height: 16px;
		text-decoration: none;
		text-transform: none;
		vertical-align: middle;
		position: relative;
		cursor: pointer;
		white-space: nowrap;
	}
	.input-class {
		height: 40px;
		padding-left: 25px;
		width: 210px;
		border: 0;
		border-radius: 4px;
	}
@media screen and (max-width: 700px) {
	.input-class {
		width: 320px;
	}
}
	</style>
